import { CheckboxProps } from "@chakra-ui/react";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';

type Props = {
  meta: FormInputMeta,
  register?: any,
  hasError?: any,
  children?: React.ReactNode
} & CheckboxProps;

export default function CustomInputCheckBox({
  children,
  meta,
  register,
  hasError,
  ...rest
}: Props) {
  
  return (
    <>
      {register ? <CC.Checkbox {...rest} {...register}>{children ? children : ""}</CC.Checkbox> : <CC.Checkbox {...rest} checked={meta?.checked}>{children ? children : ""}</CC.Checkbox>}

      {hasError && <CC.FormErrorMessage>{hasError.message}</CC.FormErrorMessage>}
    </>
  );
}
